import { rem } from 'polished'

const layout = {
  borderWidth: rem(2),
  borderRadius: rem(3),
}

export default layout
